import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import useApi from '../hooks/useApi'

export default function GroupRedirect() {
  const { groupId } = useParams()
  const navigate = useNavigate()
  const { getGroup } = useApi()

  useEffect(() => {
    const redirectToGroup = async () => {
      try {
        const { data } = await getGroup({ id: groupId })
        if (data) {
          navigate(`/groups/${data.slug || data.id}`, { replace: true })
        }
      } catch (e) {
        navigate('/groups', { replace: true })
      }
    }

    if (groupId) {
      redirectToGroup()
    }
  }, [groupId, navigate, getGroup])

  return
}
